import { ReportFeatures } from '@hcs/types';

export const REPORT_VALUE_SELECTOR_FEATURES_SALE = [
  ReportFeatures.HcAvm,
  ReportFeatures.ComparableValue,
  ReportFeatures.UserOpinionOfPrice,
  ReportFeatures.AdjustedAvm,
];
export const REPORT_VALUE_SELECTOR_FEATURES_RENTAL = [
  ReportFeatures.RentalHcAvm,
  ReportFeatures.RentalComparableValue,
  ReportFeatures.RentalUserOpinionOfPrice,
];
